import script from "./BattleResultBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleResultBlock.vue?vue&type=script&setup=true&lang=js"

import "./BattleResultBlock.vue?vue&type=style&index=0&id=3f9b9cde&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9b9cde"]])

export default __exports__